import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../Types';
import { T } from '../../../../../../../../Translations';
import ExperienceProductLabel from '../ExperienceProductLabel';
import OnDemandProgramIcon from '../Icons/OnDemandProgramIcon';
import ScheduledProgramIcon from '../Icons/ScheduledProgramIcon';
import { isScheduledCourse } from '../isScheduledCourse';

interface Props {
  experienceResource: ExperienceResource;
}

function ProgramProductBadge({ experienceResource }: Props) {
  return isScheduledCourse(experienceResource.payload) ? (
    <ExperienceProductLabel>
      <ScheduledProgramIcon size="md" />
      <T kind="Scheduled Course" />
    </ExperienceProductLabel>
  ) : (
    <ExperienceProductLabel>
      <>
        <OnDemandProgramIcon size="md" />
        <T kind="On-Demand Course" />
      </>
    </ExperienceProductLabel>
  );
}

export default observer(ProgramProductBadge);
